import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import NewsletterForm from '@/components/feature/NewsletterForm';

export default function SiteFooter() {
  return (
    <footer className="mt-20 border-t border-background-300 bg-background-200">
      <div className="mx-auto w-full px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-600 text-background-50">
                <i className="ri-leaf-line text-lg" />
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">西瓜瓜田</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              把散落在各处的娱乐线索整理成时间线、人物档案与真伪提示，让每一次吃瓜都有据可循、有理可讲。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-mail-line text-primary-600" />
              <a href="mailto:gua@xiguaguatian.example.com" className="cursor-pointer hover:text-primary-700">
                gua@xiguaguatian.example.com
              </a>
            </p>
          </div>

          <nav className="lg:col-span-2" aria-label="栏目导航">
            <h4 className="font-heading text-base font-bold text-foreground-950">栏目</h4>
            <ul className="mt-4 space-y-2 text-sm">
              {categories.slice(0, 5).map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/category/${item.slug}`}
                    className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="lg:col-span-2" aria-label="站点导航">
            <h4 className="font-heading text-base font-bold text-foreground-950">站点</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/" className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/#hot" className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700">
                  今日热瓜
                </Link>
              </li>
              <li>
                <Link to="/#guide" className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700">
                  吃瓜方法论
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700">
                  关于我们
                </Link>
              </li>
            </ul>
          </nav>

          <div className="lg:col-span-4">
            <h4 className="font-heading text-base font-bold text-foreground-950">订阅吃瓜速递</h4>
            <p className="mt-3 text-sm text-foreground-600">
              每周一封，只挑值得追的三条线索，附上更新时间线与核实结论。
            </p>
            <div className="mt-4">
              <NewsletterForm />
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 西瓜瓜田 · 理性吃瓜，不信谣不传谣</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>本站内容仅为公开讨论整理，不代替任何一方的正式声明</span>
            <Link to="/about" className="cursor-pointer hover:text-primary-700">
              内容原则
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}